import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-da-" }
const _hoisted_2 = { class: "br-da-" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", _hoisted_2, [
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/",
            class: _normalizeClass({ current: _ctx.isInHomeRoute })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Home ")
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/study",
            class: _normalizeClass({ current: _ctx.isInStudyRoute })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Study ")
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: "/study/prs",
            class: _normalizeClass({ current: _ctx.isInStudyPrsRoute })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" SPRS ")
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            to: "/review",
            class: _normalizeClass({ current: _ctx.isInReviewRoute })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Review ")
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 4,
            to: "/words",
            class: _normalizeClass({ current: _ctx.isInWordsRoute })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Word ")
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 5,
            to: "/topics",
            class: _normalizeClass({ current: _ctx.isInTopicsRoute })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Topic ")
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}